<template>
  <DashboardPanelTemplate
    :panelSize='panelSize'
    :panelFocus='panelFocus'
    :loading='loading'
    :background='"banner"'
  >
    <div class="banner-row">
      <div class="banner-check">
        <img class="check-icon" :src="require('../assets/images/checkIcon.svg')"/>
      </div>
      <div class="banner-text">
        {{$t('BannerText')}}
      </div>
      <sb-button
        @click.prevent='dismissMessage'
        class="banner-button"
      >
        {{$t('BottonText')}}
      </sb-button>
    </div>
  </DashboardPanelTemplate>
</template>
<script>
import DashboardPanelTemplate from '../../layouts/DashboardPanelTemplate'

export default {
  name: 'InfoMessageBannerPanel',
  props: {
    panelSize: {
      type: String,
      required: true
    },
    panelFocus: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    dismissMessage: {
      type: Function,
      required: true
    }
  },
  components: {
    DashboardPanelTemplate
  },
  methods: {
  },
  i18n: {
    messages: {
      'en-US': {
        BannerText: 'Based on your shipment volume, a business development representative will be in touch shortly. Feel free to follow the steps below to start setting up your account.',
        BottonText: 'Got it!'
      }
    }
  }
}
</script>
<style lang='scss'>
  .banner-background {
    padding: 0.2em 1.625em !important;
  }
</style>
<style scoped lang='scss'>
@import '../../../../assets/scss/shipbob-custom/components/dashboard/_setup-panel-fulfillment.scss';
</style>